//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'
import SupTaskChangedNotifyIcon from '../../components/SupTaskChangedNotifyIcon.vue'
import { axiosGet } from '../../axios/axios.js'
import { mapActions, mapGetters } from 'vuex'
import UpdatesManager from '../../components/UpdatesManager.js'

export default {
  components: {
    SupTaskChangedNotifyIcon
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    reportTitle: {
      type: String,
      default () {
        return ''
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      reportChangedOnServer: false,

      userLabels: '',
      updatesManager: new UpdatesManager({
        autoUpdate: true,
        updateFn: () => {
          return this.getUserLabels()
        },
        listenDocumentVisibility: true
      }),
      showMobileMultiReportTitles: false
    }
  },
  computed: {
    ...mapGetters({
      reportStateColors: 'getReportStateColors',
      reportStateTextColors: 'getReportStateTextColors'
    }),
    reportStateId: function () {
      return this.report && this.report.stateId || null
    },
    showReportStateWarning: function () {
      return !!(this.reportStateId === 'PR11')
    },
    reportStateColor: function () {
      const stateId = this.reportStateId
      return this.reportStateColors && stateId && this.reportStateColors[stateId] || null
    },
    reportStateTextColor: function () {
      const stateId = this.reportStateId
      return this.reportStateTextColors && stateId && this.reportStateTextColors[stateId] || null
    },
    reportStateLabelStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold; margin-left: 4px; padding: 0 4px;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    },
    creationTime: function () {
      if (this.report && this.report.creationTime) {
        return convertTime(this.report.creationTime)
      }
      return null
    },
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    objectNumber: function () {
      if (!this.serviceObject) {
        return null
      }
      return this.serviceObject.objectNumber || this.serviceObject.number || this.report.serviceObjectNumber || null
    }
  },
  watch: {
    reportChangedOnServer: function (value) {
      if (value) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.$emit('update')
            }
          },
          warning: ['Вы просматриваете устаревшую версию отчета.', 'Обновить страницу, загрузив актуальную версию?', 'При обновлении страницы все ваши изменения будут утеряны.'],
          buttons: [
            { key: 'yes', name: 'Обновить', color: 'blue' },
            { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
          ]
        })
      }
    }
  },
  created: function () {
    this.setCurrentDocumentLabel('report.' + this.report.id)
    this.updatesManager.onUpdate()
  },
  beforeDestroy: function () {
    this.setCurrentDocumentLabel(null)
    this.updatesManager.destroy()
  },
  methods: {
    ...mapActions({
      setCurrentDocumentLabel: 'setCurrentDocumentLabel'
    }),
    getUserLabels: function () {
      const urlParams = new URLSearchParams()
      urlParams.set('label', 'report.' + this.report.id)

      const additionalParams = {
        changeTime: this.report.uiChangeTime
      }
      urlParams.set('additional', JSON.stringify(additionalParams))

      return axiosGet({
        url: '/service/delta/report/pinguserlabels?' + urlParams.toString(),
        onFailure: 'Ошибка получения списка пользователей, просматривающих документ',
        onSuccess: (response) => {
          // this.reportChangedOnServer = response.data.reportChanged || false

          const userResults = response.data.result
          if (userResults) {
            this.userLabels = userResults.map(user => user.fio).join(', ')
          } else {
            this.userLabels = ''
          }
          return this.userLabels
        },
        msgTarget: this
      })
    },
    getRequestUrl: function (reportId) {
      for (let i = 0; i < Object.keys(this.report.requestId).length; i++) {
        const key = Object.keys(this.report.requestId)[i]
        if (+key === reportId) {
          let url = '/task/' + this.report.requestId[key] + '/document/' + reportId
          if (this.report.reports) {
            url += '?multiple=false'
          }
          return url
        }
      }
    },
    copyToClipboard: function (text, successMessage) {
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([String(text)], { type: 'text/plain' }) })]
      return navigator.clipboard.write(data).then(() => {
        this.$q.notify({
          type: 'positive',
          message: successMessage,
          progress: true,
          timeout: 3000
        })
      }).catch(() => {
        this.$q.notify({
          type: 'negative',
          message: 'Не удалось скопировать в буфер обмена',
          progress: true,
          timeout: 3000
        })
      })
    },
    onCopyObjectNumber: function () {
      if (!this.objectNumber) {
        return
      }
      this.copyToClipboard(this.objectNumber, 'Номер объекта скопирован')
    },
    onCopyTitle: function (e) {
      if (e) {
        e.stopPropagation()
      }

      let reportName = null
      if (this.report.reports) {
        reportName = 'Сводный отчёт: ' + this.report.reports.map(subReport => subReport.name).join(', ')
      } else {
        reportName = this.report.name
      }
      if (this.serviceObject && this.serviceObject.alias) {
        reportName += ' / ' + this.serviceObject.alias
      }

      this.copyToClipboard(reportName, 'Заголовок скопирован')
    }
  }
}

